import Component from '../../js/lib/component';
import anime from 'animejs';

const classList = {
  root: '.js-manufacturers',
  inner: '.js-manufacturers-inner',
  list: '.js-manufacturers-list',
  item: '.js-manufacturers-item',
  footer: '.js-manufacturers-footer',
  button: '.js-manufacturers-button'
};

const cache = {};

export default class Manufacturers extends Component {
  init() {
    this.$.root.addClass('is-inited');
    this.Switch = this.childs('Switches')._one();
    this.setState({ currentType: this.Switch.state.currentType });
  }
  events() {
    if (this.Switch) {
      this.Switch.$.root.on('switches:change', (e, { type }) => {
        this.toggle(type);
      });
    }

    this.$.button.on('click', () => {
      this.$.button.prop('disabled', true);
      this.get(this.state.currentType).then(({ html, isLast }) => {
        if (isLast) {
          this.$.footer.remove();
        }

        this.add(html);
      });
    });
  }
  toggle(type) {
    this.hide().then(() => {
      this.timer = setTimeout(() => {
        this.$.root.addClass('is-loading');
      }, 1000);

      this.load(type).then($manufacturers => {
        clearTimeout(this.timer);

        this.state.$manufacturers = $manufacturers;

        this.$.item = $manufacturers.find(classList.item);
        this.$.list = $manufacturers.find(classList.list);
        this.$.footer = $manufacturers.find(classList.footer);

        this.renderItems(this.$.inner, $manufacturers);
        this.show();

        this.$.root.removeClass('is-loading');
      });
    });
  }
  hide() {
    return new Promise(resolve => {
      anime({
        targets: this.$.list.get(0),
        opacity: 0,
        easing: 'easeOutCubic',
        duration: 300,
        complete: () => {
          this.$.root.removeClass('is-inited');
          resolve();
        }
      });
    });
  }
  load(type) {
    if (cache[type]) {
      return Promise.resolve(cache[type]);
    } else {
      return new Promise((resolve, reject) => {
        $.ajax('/brand/api/list', {
          data: { type }
        })
          .done(({ html }) => {
            const $manufacturers = $(html);
            cache[type] = $manufacturers;
            resolve($manufacturers);
          })
          .fail(error => {
            console.error(error);
            reject(error);
          });
      });
    }
  }
  get(type) {
    return new Promise((resolve, reject) => {
      $.ajax('http://localhost:3333/manufacturers/', {
        data: { type }
      })
        .done(({ html, isLast }) => {
          resolve({ html, isLast });
        })
        .fail(error => {
          console.error(error);
          reject(error);
        })
        .always(() => {
          this.$.button.prop('disabled', false);
        });
    });
  }
  add(manufacturers) {
    this.$.list.append(manufacturers);
  }
  renderItems($container, $content) {
    $container.html($content);
  }
  show() {
    const targets = this.$.item.get();

    anime.set(targets, {
      opacity: 0,
      translateY: 30
    });

    if (this.Switch) {
      this.Switch.toggle();
    }

    anime({
      targets,
      opacity: 1,
      translateY: 0,
      easing: 'easeOutCubic',
      duration: 300,
      delay: anime.stagger(70)
    });
  }
}

Component.mount(Manufacturers, {
  name: 'Manufacturers',
  classList,
  state: {
    currentType: '',
    $manufacturers: null
  }
});
